function initFlickityCarouselInSection(section) {
  const carousel = section.querySelector('.enavi-collection-list__carousel');
  if (carousel && !carousel.classList.contains('flickity-initialized')) {
    carousel.classList.add('flickity-initialized');
    const flkty = new Flickity(carousel, {
      cellAlign: 'left',
      contain: true,
      prevNextButtons: true,
      pageDots: true,
      wrapAround: false,
      adaptiveHeight: false,
      cellSelector: '.enavi-collection-card-wrapper',
      groupCells: false,
      arrowShape: {
        x0: 10,
        x1: 60, y1: 50,
        x2: 65, y2: 45,
        x3: 20
      }
    });

    function updateArrows() {
      const prevButton = carousel.querySelector('.flickity-prev-next-button.previous');
      const nextButton = carousel.querySelector('.flickity-prev-next-button.next');
      if (prevButton) {
        prevButton.style.display = flkty.selectedIndex === 0 ? 'none' : 'block';
      }
      if (nextButton) {
        const lastSlide = flkty.slides[flkty.slides.length - 1];
        const lastSlideCell = lastSlide.getCellElements()[0];
        const isLastSlideFullyVisible = !lastSlideCell.classList.contains('enavi-collection-card--grayed');
        nextButton.style.display = isLastSlideFullyVisible ? 'none' : 'block';
      }
    }

    function updateCellOpacity() {
      const cells = flkty.getCellElements();
      const carouselRect = carousel.getBoundingClientRect();
      cells.forEach(cell => {
        const cellRect = cell.getBoundingClientRect();
        const visibleWidth = Math.min(cellRect.right, carouselRect.right) - Math.max(cellRect.left, carouselRect.left);
        const visiblePercentage = visibleWidth / cellRect.width;
        cell.classList.toggle('enavi-collection-card--grayed', visiblePercentage < 0.6);
      });
    }

    function resizeFlickity() {
      if (window.innerWidth >= 768) {
        flkty.options.groupCells = false;
      } else {
        flkty.options.groupCells = true;
      }
      flkty.resize();
      updateCellOpacity();
      updateArrows();
    }

    flkty.on('ready', () => {
      updateCellOpacity();
      updateArrows();
    });
    flkty.on('scroll', () => {
      updateCellOpacity();
      updateArrows();
    });
    flkty.on('select', updateArrows);

    resizeFlickity();
    window.addEventListener('resize', resizeFlickity);
  }
}

function initAllFlickityCarousels() {
  document.querySelectorAll('product-recommendations.enavi-collection-list').forEach(section => {
    initFlickityCarouselInSection(section);
  });
}

document.addEventListener('DOMContentLoaded', initAllFlickityCarousels);
document.addEventListener('shopify:section:load', initAllFlickityCarousels);

document.addEventListener('product-recommendations:loaded', function(e) {
  if (e.target.matches('product-recommendations.enavi-collection-list')) {
    initFlickityCarouselInSection(e.target);
  }
});